module.exports = __webpack_public_path__ + "static/media/MEDI.8120a1fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/MEDI.jpg
// module id = 1365
// module chunks = 1